import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatListOption } from "@angular/material/list";
import { MatSelect, MatSelectChange } from "@angular/material/select";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { Configuration } from "../core/configuration";
import { Content } from "../core/models/content";
import { Option, OptionsContent, OptionsDisplay } from "../core/models/options-content";
import { ConfigurationLoader } from "../core/services/configuration-loader.service";

/**
 * Componente responsável pela exibição do conteúdo de mensagens de opções.
 * A exibição do conteúdo depende do modelo de exibição selecionado por OptionsDisplay.
 * 
 * Este componente lança o evento optionSelected toda vez que uma opção é selecionada pelo
 * usuário, caso seja possível realizar uma seleção, pois há tipos de exibição que não permitem
 * a seleção.
 */
@Component({
    selector: 'serprobots-message-options-content',
    templateUrl: 'options-content.component.html',
    styleUrls: ['options-content.component.css']
})
export class OptionsContentComponent implements OnInit {

    // Conteúdo que deve ser exibido pelo componente.
    @Input() content: Content = new OptionsContent("", OptionsDisplay.SELECTION_LIST);

    // Informa se as opções exibidas na tela devem ser desabilitadas para seleção
    // após o usuário selecionar uma opção.
    @Input() disableAfterSelection: boolean = false;

    // Evento lançado quando uma opção é selecionada.
    @Output() optionSelected = new EventEmitter<Option>();

    // Lista de Opções de Exibição para que possam ser acessíveis pelo template.
    displayButton: OptionsDisplay = OptionsDisplay.BUTTON;
    displaySelectionList: OptionsDisplay = OptionsDisplay.SELECTION_LIST;
    displaySimpleList: OptionsDisplay = OptionsDisplay.SIMPLE_LIST;
    displayDropdown: OptionsDisplay = OptionsDisplay.DROPDOWN;

    configuration: Configuration = new Configuration({});
    disableOptionsInput: boolean = false;
     
    constructor(
        private sanetize: DomSanitizer,
        private configurationLoader: ConfigurationLoader
    ) {}

    async ngOnInit(): Promise<void> {
        this.configuration = await this.configurationLoader.getConfiguration();
    }

    getOptions(): Option[] {
        return (this.content as OptionsContent).options;
    }

    getDisplay(): OptionsDisplay {
        return (this.content as OptionsContent).display;
    }

    getTitle(): SafeHtml {        
        let text = ""
        let option = (this.content as OptionsContent)
        if(option.title){
            text = option.title.replace(/(?:\r\n|\r|\n)/g, '<br>');
        }
        return this.sanetize.bypassSecurityTrustHtml(text);
    }
    
    onOptionSelected(option: Option): void {
        this.optionSelected.emit(option);
        this.disableOptionsInput = this.disableAfterSelection;
    }

    onMatSelectOptionSelected(option: any): void {
        this.optionSelected.emit(option);
        this.disableOptionsInput = this.disableAfterSelection;
    }

    onSelecionListClicked(option: any) {
        this.optionSelected.emit(option);
        this.disableOptionsInput = this.disableAfterSelection;
    }
    
}